import React, { createContext, useContext, useState, ReactNode, useCallback } from 'react'
import BlockUI from 'utils/BlockUiGenerico'

type BlockUIContextType = {
  blocking: boolean
  showBlock: (mensaje?: string) => void
  hideBlock: () => void
}

const BlockUIContext = createContext<BlockUIContextType>({
  blocking: false,
  showBlock: () => { },
  hideBlock: () => { },
})

export const useBlockUI = () => useContext(BlockUIContext)

export const BlockUIProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [blocking, setBlocking] = useState(false)
  const [mensaje, setMensaje] = useState('Procesando...')

  const showBlock = useCallback((msg?: string) => {
    setMensaje(msg || 'Procesando...')
    setBlocking(true)
  }, [])

  const hideBlock = useCallback(() => {
    setBlocking(false)
  }, [])

  return (
    <BlockUIContext.Provider value={{ blocking, showBlock, hideBlock }}>
      {children}
      <BlockUI blocking={blocking} mensaje={mensaje} children={undefined} />
    </BlockUIContext.Provider>
  )
}
